<template>
	<div class="view flex-parent">
		<div class="container main border-l">
			<h1 class="number mb-16 mt-8">404</h1>
			<p>Sorry about that lmao.</p>
			<secondary-button
				class="mt-24 full-width"
				@click="$router.push('/login')"
				>Back to home</secondary-button
			>
		</div>
	</div>
</template>

<script>
import SecondaryButton from "../components/ui/SecondaryButton";
export default {
	components: {
		SecondaryButton,
	},
};
</script>

<style lang="scss" scoped>
.container {
	min-width: 320px;
	max-width: 400px;
}
.number {
	font-size: 48px;
}
</style>
